import { render, staticRenderFns } from "./string.vue?vue&type=template&id=8bcff388"
import script from "./string.vue?vue&type=script&lang=ts"
export * from "./string.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports